// /src/routes/navbar/navbar.lang.en.js
const navbarEN = {
	brand: "SinFila",

	admin: {
		calendar: "Calendar",
		profile: "Profile",
		billing: "Billing",
		team: "Team",
		reports: "Reports",
		account: "Account",

		// Scheduling
		staffSchedule: "Staff Schedule",
		openingHours: "Opening Hours",

		// Onboarding / setup
		showSteps: "Show Steps",
		hideSteps: "Hide Steps",
		stepsCompleted: "{done} / {total} steps completed ({percent}%)",
		launchShop: "Launch Shop",
		launchStaff: "Launch Staff",
		launchingStaff: "Launching Staff",
		redirecting: "Redirecting...",
		billingError: "Unable to start billing",
	},

	search: {
		placeholder: "Search",
		where: "Where?",
		button: "Search",
	},

	auth: {
		signin: "Sign in",
		logout: "Log out",
		listShop: "List your shop",
		profile: "Profile",
		shop: "Shop",
	},

	language: {
		english: "English",
		spanish: "Español",
	},

	categories: {
		hairsalon: "Hair Salon",
		barbershop: "Barbershop",
		nailsalon: "Nail Salon",
		skincare: "Skin Care",
		browslashes: "Brows & Lashes",
		massage: "Massage",
		makeup: "Makeup",
		wellnessspa: "Wellness & Day Spa",
	},

	mobile: {
		home: "Home",
		bookings: "Bookings",
		list: "List",
		signin: "Sign in",
		logout: "Logout",
		business: "Business",
		explore: "Explore",
	},
};

export default navbarEN;
